import React from "react";

import { NavLink } from "react-router-dom";

import type { JSX } from "react";

interface NavbarLogoProps {
  name: string;
  url: string;
  height: string;
}

export default function NavbarLogo({
  name,
  url,
  height,
}: NavbarLogoProps): JSX.Element {
  return (
    <div className="navbar-logo-container" style={{ height }}>
      <NavLink to="/">
        <img alt={name} height={height} src={url} />
      </NavLink>
    </div>
  );
}
